import axios from 'axios';
import { $on, qs, qsa } from './utils';

const formData = new FormData(); 
// todo: move this code to api service
const PROD_ENV = 'https://api.hourmane.com/api';
const DEV_ENV = 'https://api.dev.hourmane.com/api';
const BASE_URL = location.hostname.includes('hourmane.com') ? PROD_ENV : DEV_ENV;

$on(qs('#queryForm'), 'submit', async function(event) {
    // event.stopImmediatePropagation();
    event.preventDefault();

    qsa('.query-item').forEach(el => {
      formData.append(el.name, el.value);
    });

    await axios.post(`${BASE_URL}/v1/inquiry/hourmane`, formData)
    .then(response => {
      if (response.data.result === 'ok') { 
         qs('#queryForm').reset();
         window.location.href = '/inquiry-complete'; 
      }
    })
    .catch(error => {
      throw(error.message);
    });
});
